<div class="inline-alert" [ngClass]="type" role="alert">
  <p>{{ message }}</p>
</div>
